import mockData from "../utils/filter";
import FilterTh from "../utils/th-Filter";
import EmptyTh from "../utils/th-Empty";

import Masivo from "../Masivo";
import moment from "moment";

export default {
  props: {
    showtable: Boolean,
    operadores: {
      default: [],
    },
    trabajadores: {
      default: [],
    },
    actividades: {
      default: [],
    },
    ubicaciones: {
      default: [],
    },
    ubicacionesRaiz: {
      default: [],
    },
  },
  components: {
    FilterTh,
    EmptyTh,
    Masivo,
  },
  data() {
    return {
      filter: {},
      tblStyle: {
        "table-layout": "fixed",
      },
      selection: [],
      query: {
        limit: 10,
      },
      total: 0,
      data: [],
      filtered: [],
      filterApply: false,
      watcher: false,
      dataCached: {},
      deletePrompt: false,
      deletePromptMeta: [],
      isLoading: true,
      toastsKey: 0,
      chunkSize: 50,
    };
  },
  methods: {
    filterReport() {
      return Object.keys(this.filter).reduce((v, key) => {
        if (key === "periodo") {
          v.fecha = [
            moment(this.filter[key].start).format("YYYY-MM-DD 00:00:00"),
            moment(this.filter[key].end).format("YYYY-MM-DD 23:59:59"),
          ];
        } else {
          v[key] = this.filter[key].map((m) => m.id);
        }

        return v;
      }, {});
    },
    setPeriodo(v) {
      this.filter.periodo = v;
    },
    actualizarInfo(from = "") {
      this.isLoading = true;
      this.consultarDocumentos(from).finally(() => {
        this.isLoading = false;
        this.watcher = true;
        this.updateHeightRows();
      });
    },
    deletePromptAction() {
      this.syncEliminar(this.deletePromptMeta).finally(() => {
        this.watcher = false;
        this.deletePromptMeta.map((file) => {
          const index = this.data.findIndex((row) => row.file == file);
          const removed = this.data.splice(index, 1);
          delete this.dataCached[removed[0].nanoid];
        });
        this.deletePromptMeta = [];
        this.deletePrompt = false;
        this.watcher = true;
        this.handleQueryChange("deletePromptAction=>syncEliminar.finally");
      });
    },
    handleQueryChange(from) {
      mockData(this.query, this.data, this.columns, this.$parent.$data).then(
        ({ rows, total, filterApply }) => {
          this.filterApply = filterApply;
          this.filtered = rows;
          console.log(from);

          this.total = total;
        }
      );
    },
    syncConsultar_(from) {
      this.data = [];
      this.dataCached = {};
      this.filtered = [];

      return this.$store
        .dispatch("httpAny", {
          endpoint: "sync:consultar_documentos",
          body: {
            schema: this.schema,
            ubicacion_raiz_id: this.ubicacionRaiz.value,
            params: this.filterReport(),
          },
        })
        .then((response) => {
          if (response.status == "success") {
            const chunkData = [];
            for (let i = 0; i < response.data.length; i += this.chunkSize) {
              chunkData.push(response.data.slice(i, i + this.chunkSize));
            }
            if (!chunkData.length) {
              return Promise.resolve([]);
            }
            return new Promise((resolve) => {
              chunkData.forEach((chunk, index) => {
                this.data.push(...chunk.map(this.mapChunkData));
                if (chunkData.length - 1 === index) {
                  resolve("hola");
                }
              });
            });
          }
        })
        .then((res) => {
          console.log(res);
          this.handleQueryChange(`${from}::syncConsultar_=>httpAny.then`);
        });
    },
    syncRecargar(documentos) {
      if (documentos.length === 0) {
        return Promise.reject();
      }
      const data = {
        endpoint: "sync:recargar_documentos",
        body: {
          documentos: documentos,
        },
      };
      console.log(data);
      debugger;
      return this.$store.dispatch("httpAny", data);
    },
    syncEliminar(documentos) {
      return this.$store.dispatch("httpAny", {
        endpoint: "sync:eliminar_documentos",
        body: {
          documentos: documentos,
        },
      });
    },
    recargarDocumentos() {
      this.isLoading = true;
      this.watcher = false;
      this.syncRecargar(this.localDocuments)
        .then(() => {
          this.consultarDocumentos(
            "recargarDocumentos=>syncRecargar.then"
          ).finally(() => {
            this.isLoading = false;
            this.watcher = true;
            this.handleQueryChange(
              "recargarDocumentos=>syncRecargar.then=>consultarDocumentos.finally"
            );
            this.updateHeightRows();
          });
        })
        .catch(() => {
          this.consultarDocumentos(
            "recargarDocumentos=>syncRecargar.catch"
          ).finally(() => {
            this.isLoading = false;
            this.watcher = true;
            this.handleQueryChange(
              "recargarDocumentos=>syncRecargar.catch=>consultarDocumentos.finally"
            );
            this.updateHeightRows();
          });
        });
    },
    actividad(actividad_id, param) {
      let actividad = this.actividades.find(
        (child) => child.id == actividad_id
      );
      if (actividad) {
        if (param !== undefined) {
          return actividad[param] || "";
        }
        return actividad;
      }
    },
    trabajador(trabajador_id, param) {
      let trabajador = this.trabajadores.find(
        (trabajador) => trabajador.id == trabajador_id
      );
      if (trabajador) {
        if (param !== undefined) {
          return trabajador[param] || "";
        }
        return trabajador;
      }
    },
    embalajes(cultivo_id) {
      let cultivo = this.cultivos.find((element) => element.id == cultivo_id);
      if (cultivo) {
        return cultivo.embalajes.map((item) => {
          return {
            id: item.nombre,
            label: item.nombre,
          };
        });
      }
      return [];
    },
    arbolPertenencias(data) {
      const presort = data.sort((a, b) => a.ruta.localeCompare(b.ruta));

      const reduceData = presort.reduce((acc, item) => {
        let nodo = {
          id: item.id,
          label: item.nombre,
          pertenece_id: item.pertenece_id,
        };
        const navi = item.ruta.split("/").slice(1, -2);

        let pointer = acc;
        navi.forEach((nav, index) => {
          let find = pointer.find((f) => f.id == nav);
          if (!find.children) {
            find.children = [];
          }
          pointer = find.children;
        });
        pointer.push(nodo);

        return acc;
      }, []);

      return reduceData;
    },
    onDeleteItem(registro) {
      this.deletePromptMeta = [registro.rowData.file];
      this.deletePrompt = true;
    },
    onDeleteAll() {
      this.deletePromptMeta = this.selection.map((item) => item.file);
      this.deletePrompt = true;
    },
    onUndoItem(registro) {
      const nanoid = registro.rowData.nanoid;
      const index = this.data.findIndex((row) => row.nanoid == nanoid);
      const copy = [...this.data];
      if (this.dataCached[nanoid]) {
        copy[index] = this.dataCached[nanoid];
        delete this.dataCached[nanoid];
      }
      this.watcher = false;
      this.data = JSON.parse(JSON.stringify(copy));

      this.watcher = true;
      this.handleQueryChange("onUndoItem");
    },
    updateAll() {
      this.selection = [];
    },
    dateFormat(date) {
      return moment(date).format("DD/MM/YY hh:mm a");
    },
    updateHeightRows() {
      const trs = [
        ...document.querySelectorAll('[name="RightFixedTableBody"] tr'),
      ];
      for (const [i, v] of trs.entries()) {
        const index = i + 1;
        const height = document.querySelector(
          `[name="NormalTableBody"] tr:nth-child(${index})`
        ).clientHeight;
        v.style.height = height + "px";
      }
    },
  },
  computed: {
    actividadC() {
      return this.actividades.reduce((v, c) => ({ ...v, [c.id]: c }), {});
    },
    localDocuments() {
      return [...this.dirtyDocuments, ...this.unDirtyDocuments].reduce(
        (v, c) => {
          if (!v.find((f) => f.file == c.file)) {
            v.push(c);
          }
          return v;
        },
        []
      );
    },
    actividadesArbol() {
      return this.arbolPertenencias(this.actividades).filter((obj) => {
        return obj.pertenece_id === 0;
      });
    },
    ubicacionesArbol() {
      return this.arbolPertenencias(this.ubicaciones);
      // .filter(obj => {
      //   return obj.id === this.ubicacionRaiz.value;
      // });
    },
    ubicacionRaiz() {
      return this.$store.state.rootLocation;
    },
    xdata() {
      const isLoading = this.isLoading ? "isLoading" : "isNotLoading";
      console.log(
        isLoading,
        this.data.length,
        this.filterApply,
        this.filtered.length
      );
      return !this.isLoading
        ? this.filterApply
          ? this.filtered
          : this.data
        : [];
    },
    dataString() {
      return !this.isLoading
        ? this.data.map((item) => JSON.stringify(item))
        : [];
    },
    touches() {
      const touched =
        this.dirtyDocuments.length +
        this.selection.filter((ff) => !ff.dirty).length;
      this.$emit("update-touched", {
        from: touched,
        to: !this.isLoading ? this.data.length : 0,
      });
      return touched;
    },
    trabajadoresActivos() {
      return this.trabajadores.filter((trabajador) => {
        return trabajador.deleted == false;
      });
    },
  },
  watch: {
    query: {
      handler() {
        this.handleQueryChange("watch=>query");
      },
      deep: true,
    },
    dataString: {
      handler(newValue, oldValue) {
        // console.log({newValue, oldValue})
        console.log(this.watcher);
        if (this.watcher) {
          for (const index in newValue) {
            if (newValue[index] != oldValue[index]) {
              let newValueParsed = newValue[index]
                ? JSON.parse(newValue[index])
                : {};
              let oldValueParsed = oldValue[index]
                ? JSON.parse(oldValue[index])
                : {};
              if (this.dataCached[oldValueParsed.nanoid] == undefined) {
                this.dataCached[oldValueParsed.nanoid] = oldValueParsed;
              }
              if (Object.keys(oldValueParsed).length == 0) {
                return;
              }
              for (const [key, value] of Object.entries(newValueParsed)) {
                if (
                  key != "dirty" &&
                  (oldValueParsed[key] ?? "").toString() !== value.toString()
                ) {
                  let error = this.data[index].errors.findIndex(
                    (error) => error == key
                  );
                  if (error >= 0) {
                    this.data[index].errors.splice(error, 1);
                  }
                  this.data[index].dirty = true;
                }
              }
            }
          }
        }
      },
      deep: true,
    },
  },
  created() {
    console.log("consultarDocumentos");

    this.isCreated = true;

    this.filter.periodo = {
      start: moment().startOf("month").toDate(),

      end: moment().endOf("month").toDate(),
    };
    this.isLoading = false;
  },
};
